import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IconComponent } from '../../../components/icon/icon.component';
import { PaymentDone } from '../../../domain/models/payment-done';
import { Table } from '../../../domain/models/table';
import { CurrencyPipe } from '../../../pipes/currency.pipe';
import { ReceiptItemTableComponent } from '../receipt-item-table/receipt-item-table.component';
import { PaymentItem } from '../../../domain/models/payment-done';
import { UserService } from '../../../domain/services/user.service';

/** os itens de uma pessoa dentro do comprovante; name null = sem dono */
interface OwnerSection {
  userId: number | null;
  name: string | null;
  items: PaymentItem[];
}

@Component({
    selector: 'app-receipt',
    imports: [
        CommonModule,
        CurrencyPipe,
        IconComponent,
        ReceiptItemTableComponent,
    ],
    templateUrl: './receipt.component.html',
    styleUrl: './receipt.component.scss'
})
export class ReceiptComponent {

  @Input() payment: PaymentDone;
  @Input() table: Table;
  collapsed: boolean = false;

  constructor(private userService: UserService) {}

  /** Fatia os itens por quem pediu: sem dono primeiro, depois quem está olhando, depois os outros. */
  get ownerSections(): OwnerSection[] {
    const loggedUserId = this.userService.getUser()?.id;
    const sections = new Map<number | null, OwnerSection>();

    for (const paymentItem of this.payment.items ?? []) {
      const key = paymentItem.item.userId ?? null;
      if (!sections.has(key)) {
        sections.set(key, { userId: key, name: key == null ? null : paymentItem.item.userName, items: [] });
      }
      sections.get(key)!.items.push(paymentItem);
    }

    return [...sections.values()].sort((a, b) => {
      if (a.userId == null) return -1;
      if (b.userId == null) return 1;
      if (a.userId === loggedUserId) return -1;
      if (b.userId === loggedUserId) return 1;
      return 0;
    });
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }
}
